import isArray from "lodash/isArray";

/**
 * Get gallery image URLs for a package (agent profile + mini-site).
 * Same logic as PackagesProfile: hotelResource, selectedResult.hotel, selectedResult.images/resource.
 * @param {object} selectedResult - package/selected result
 * @param {object|array|null} hotelResource - from context (getHotelInfo or snapshot)
 * @returns {string[]} array of image URLs
 */
export function getPackageGalleryImages(selectedResult, hotelResource) {
  const resourceUrlsFromContext = isArray(hotelResource)
    ? hotelResource?.map((item) => item?.resourceUrl ?? item?.url).filter(Boolean)
    : hotelResource?.resourceUrl
      ? [hotelResource.resourceUrl]
      : hotelResource?.url
        ? [hotelResource.url]
        : [];

  const hotelFromDeal = selectedResult?.hotel ?? selectedResult?.deal?.hotel;
  const fallbackUrl =
    hotelFromDeal?.resourceUrl ||
    hotelFromDeal?.resource?.resourceUrl ||
    hotelFromDeal?.resource?.url ||
    hotelFromDeal?.image ||
    hotelFromDeal?.imageUrl ||
    hotelFromDeal?.hotelImage ||
    null;

  const fromHotelResource =
    resourceUrlsFromContext.length > 0
      ? resourceUrlsFromContext
      : fallbackUrl
        ? [fallbackUrl]
        : isArray(hotelFromDeal?.resource)
          ? hotelFromDeal.resource.map((r) => r?.resourceUrl ?? r?.url).filter(Boolean)
          : [];

  const fromSelectedResultImages = isArray(selectedResult?.images)
    ? selectedResult.images.map((item) => item?.url ?? item?.resourceUrl ?? (typeof item === "string" ? item : null)).filter(Boolean)
    : selectedResult?.resource
      ? (isArray(selectedResult.resource) ? selectedResult.resource.map((r) => r?.url ?? r?.resourceUrl).filter(Boolean) : [selectedResult.resource?.url ?? selectedResult.resource?.resourceUrl].filter(Boolean))
      : [];

  const seen = new Set();
  const merged = [];
  const pushDedup = (u) => {
    const s = u != null ? String(u).trim() : "";
    if (!s || seen.has(s)) return;
    seen.add(s);
    merged.push(s);
  };
  for (const u of fromHotelResource) pushDedup(u);
  for (const u of fromSelectedResultImages) pushDedup(u);

  return merged;
}
